import { gql } from "@apollo/client";

import timelineEntryFragment from "./timeline-entry-fragment";

/**
 * The Timeline of a review nobody has saved yet, asked for with the values the
 * setup form holds right now.
 *
 * Every argument carries the name and the meaning it has on the save mutation, so
 * the answer describes the review the admin is about to create rather than the one
 * that is stored. `complianceProgramId` starts the answer from a saved draft and
 * the arguments given here win over it, which is what lets a half-edited draft be
 * planned. Nothing on this path writes.
 */
export default gql`
  query getComplianceProgramTimelinePreview(
    $organizationId: Int!
    $complianceProgramId: Int
    $title: String
    $startDate: Date
    $dueDate: Date
    $periodStartDate: Date
    $periodEndDate: Date
    $steps: [ComplianceProgramStepInput]
    $assessmentTemplates: [AssessmentTemplateComplianceRequirement]
    $topicTemplates: [TopicTemplateComplianceRequirement]
    $calibration: ComplianceProgramCalibrationType
    $recurrence: ComplianceProgramRecurrence
    $ongoing: Boolean
    $startDateOffset: Int
    $startDateDueDateOffset: Int
    $scheduledReminders: [ProgramScheduledReminderInput]
    $appliesTo: ComplianceProgramAppliesTo
    $appliesToTeams: [Int]
    $appliesToManagers: [Int]
    $appliesToUsers: [Int]
    $excludedUsers: [Int]
    $excludedHireDateAfter: Date
    $removeExcludedHireDateAfter: Boolean
  ) {
    complianceProgramTimeline(
      organizationId: $organizationId
      complianceProgramId: $complianceProgramId
      title: $title
      startDate: $startDate
      dueDate: $dueDate
      periodStartDate: $periodStartDate
      periodEndDate: $periodEndDate
      steps: $steps
      assessmentTemplates: $assessmentTemplates
      topicTemplates: $topicTemplates
      calibration: $calibration
      recurrence: $recurrence
      ongoing: $ongoing
      startDateOffset: $startDateOffset
      startDateDueDateOffset: $startDateDueDateOffset
      scheduledReminders: $scheduledReminders
      appliesTo: $appliesTo
      appliesToTeams: $appliesToTeams
      appliesToManagers: $appliesToManagers
      appliesToUsers: $appliesToUsers
      excludedUsers: $excludedUsers
      excludedHireDateAfter: $excludedHireDateAfter
      removeExcludedHireDateAfter: $removeExcludedHireDateAfter
    ) {
      ...TimelineEntry
    }
  }
  ${timelineEntryFragment}
`;
